export const validProfile = (user) => {
  const { dt_dob, weight } = user || {};
  return !!dt_dob && dt_dob.length && typeof weight === "number";
};
